import LXPIconLib from './lxp'

export default {
  lxp: LXPIconLib
}
